import { observer } from 'mobx-react';
import React from 'react';
import placementTestReportTestDialogService from '../../services/PlacementTesReportTestDialogService';
import ErrorsPerAbilityChart from './ErrorsPerAbilityChart';

function GlobalErrorsPerAbilityChartContainer() {
  return <ErrorsPerAbilityChart data={placementTestReportTestDialogService.errorsPerAbility} />;
}

export default observer(GlobalErrorsPerAbilityChartContainer);
